$(document).ready(function() {

  $('.simple_form.newsletter').on('submit', function(e){
    $(this).find("[type='submit']").prop("disabled", true);
  });

  $('.simple_form.newsletter').on('ajax:error', function(e) {
    [data, status, xhr] = e.detail
    $(this).find('.message').text(data.message)
  }).on('ajax:success', function(e) {
    [data, status, xhr] = e.detail
    $(this).find('.message').text(data.message)
  })

});
